enum workspaceProjectImpactFrameworkChainProblemType {
  'Cause' = 'Cause',
  'Barrier' = 'Barrier',
  'Driver' = 'Driver',
}

export default workspaceProjectImpactFrameworkChainProblemType
